import { type FC } from 'react';

import { BackgroundWrapper } from '@/components/ui/BackgroundWrapper/BackgroundWrapper';
import { StarsPattern } from '@/components/ui/StarsPattern/StarsPattern';

import css from './styles.module.scss';

const Background: FC = () => {
  return (
    <BackgroundWrapper className={css.selectVipPriceBg}>
      <div>
        <div className={css.linearGradient}></div>
        <div className={css.ellipse}></div>
      </div>
      <div className={css.gradient}></div>
      <StarsPattern className={css.starsPattern} />
    </BackgroundWrapper>
  );
};

export { Background };
